module.exports = __webpack_public_path__ + "static/media/rounded-green-tick.a94299ac.svg";